<!-- 个人优势 -->
<template>
  <div class="advantage">
    <van-field
      v-model="message"
      rows="5"
      autosize
      type="textarea"
      maxlength="200"
      placeholder="请简单介绍下自己吧~"
      show-word-limit
    />
  </div>
</template>

<script>

export default {
  components: {},
  data() {
    return {
     content:''
     
    };
  },
  computed: {
    message:{
      get(){
        return this.content
      },
      set(val){
        this.content=val
        this.$emit('sendMsg',val,false)
      }
    }
  },

  methods: {},
  created() {},
  mounted() {}
};
</script>
<style lang='less' scoped>
.van-cell{
padding: 0.3rem 0.44rem;
}
/deep/.van-field__control{
  border-bottom: 0.01rem solid #E5E5E5;
}
</style>